import { render, staticRenderFns } from "./FreeShipping.vue?vue&type=template&id=5aefaeb4&lang=html"
import script from "./FreeShipping.vue?vue&type=script&lang=js"
export * from "./FreeShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports